export const SOCKET_EVENTS = {
  DO_BET_RESULT_QUEUE: 'DoBetResultQueue',
  CASH_OUT_RESULT_QUEUE: 'CashOutResultQueue',
};
